import React from 'react';
/*

MESSAGES.JSX

  This file is a convenient location for managing copy within the app.
  The majority of the text within the app is included this file, with
  the exception of configurations for things like grids + forms.

  The idea is that future copy writers, solution owners, or translators
  will be able to more easily modify this file's content to improve
  phrasing or engage in internationalization

*/

export default {
  // Global
  Form: {
    emailLabel: 'Email: ',
    phoneLabel: 'Phone: ',
    faxLabel: 'Fax: ',
    submitButton: 'Submit',
    continueButton: 'Continue',
    backButton: 'Back',
    cancelButton: 'Cancel',
    requiredFields: 'Required fields are marked with an asterisk',
    required: 'Required',
    save: 'Save',
  },
  Errors: {
    missingAuthToken: 'Could not make request because no auth token was found',
    missingQueryArg:
      'Could not make request because the query argument is missing',
    serverError:
      'There was a problem with the server during submission, please try again in a few minutes. If the problem persist...',
    submissionError: 'There was a problem during submission, please try again',
    missingRecipients: 'Please Add Recipients',
    generalError:
      'Oops, Something Went Wrong Please Try Again. If The Problem Persists Please Contact Support',
    rfqNotFound: 'Oops, We Cannot Find The RFQ You Are Looking For',
    quoteMissing: 'Oops, We Cannot Find The Qoute You Are Looking For',
    missingPermissionsContract:
      'You Do Not Have Permission to View and Edit Contracts',
  },
  Success: {
    updatedOrganizaton: 'Organization updated!',
    createdOrganization: 'Organization created!',
    deletedOrganization: 'Organization deleted!',
    updatedUser: 'User updated!',
    createdUser: 'User created!',
    deletedUser: 'User Deleted!',
    updatedTooling: 'Tooling updated!',
    createdTool: 'Tooling created!',
    deletedTool: 'Tooling deleted!',
    addMatchsSettings: 'Added bid match settings!',
    updatedMatchSettings: 'Updated bid matching settings!',
  },
  Filters: {
    issueDate: 'Issue Date',
    returnDate: 'Close Date',
    quantity: 'Quantity',
  },
  // Components
  FilterGroup: {
    viewAll: 'View All',
    viewLess: 'View Less',
  },
  // Component - Solicitations Menu
  SolicitationsMenu: {
    clearAll: 'Clear Filters',
    header: 'Filter Your Results',
    suspectCastingSwitch: 'Suspect Castings',
  },
  // Solictiation table header tooltips
  SolicitationsToolTips: {
    date: 'Solicitation issue date',
    solicitationNum: 'Solicitation number',
    closeDate: 'Solicitation close date',
    status: '',
    nsn: 'National stock number of part being requested by solicitation',
    lastAward: 'Last Award Date',
    myPartNumber:
      'Populates the part number if your organization has a matching tooling record',
    toolingCage: 'Tooling CAGE',
    description: 'Description of part being requested in solicitation',
    qty: 'The quantity of parts being requested based on unit of issue',
    ui: 'The unit of issue of the parts being requested',
    estValue: 'Estimated dollar value of solicitation',
    srva:
      'Supplier Requirements Visibility Application - DLA requirement quantity projected for next two years',
    type: 'Casting or Suspect Casting',
    amc:
      'Acquisition Method Code (first digit) Acquisition Method Suffix Code (second digit)',
    material: 'Part material',
    method: 'Casting Method',
  },
  // Component - Top Nav
  TopNav: {
    brandText: 'ICON',
    item1: 'Item Search',
    procurementHistory: 'Procurement history',
    item2: 'About',
    item3: 'Contact',
    item4: 'Solicitations',
    item5: 'Supplier Capabilites',
    userDropdown: {
      register: 'Register',
      pdmi: 'PDMI Credentials',
      bidMatching: 'Bid Matching',
      notifications: 'Notifications',
      accountOrginization: 'Organization Administration',
      toolingManagement: 'Tooling Management',
      superAdminHome: 'Super Admin Home',
    },
    supportDropdown: {
      support: 'Support',
      iconfaqs: 'FAQs',
      registration: 'Registration',
      cfolders: 'PDMI cFolders',
      help: 'Help',
      pnHelp: 'Part Numbers',
      cdHelp: 'Code Definitions',
      solHelp: 'Solicitations',
      relNotesHelp: 'Release Notes',
      newslettersHelp: 'Newsletters',
    },
  },
  // Component - Notification Card
  NotificationCard: {
    minIssueDate: 'From Issue Date',
    maxIssueDate: 'To Issue Date',
    minDueDate: 'From Due Date',
    maxDueDate: 'To Due Date',
  },
  // Component - Admin Menu

  AdminMenu: {
    header: 'Organization Administration',
  },
  // Component - Notification Card
  ViewUsersGrid: {
    noDataText: 'No results. Please update your search criteria and try again.',
  },
  ViewPendingRequest: {
    noDataText: 'No results. Please update your search criteria and try again.',
  },
  // Component - PDMI Form
  PdmiForm: {
    username: 'PDMI Username',
    password: 'Password',
    passwordConfirmation: 'Password Confirmation',
  },
  // Form - NewOrganization
  OrganizationForm: {
    organizationName: 'Organization Name',
    cageCode: 'CAGE Code',
    address1: ' Address 1',
    address2: 'Address 2',
    address3: 'Address 3',
    city: 'City',
    state: 'State/Province',
    stateZip: 'State & Zip',
    websiteUrl: 'Website URL',
    zipcode: 'ZIP/Postal Code',
    country: 'Country',
    contactName: 'Contact Name',
    contactEmail: 'Contact Email',
    contactPhone: 'Contact Phone',
    contactFax: 'Contact Fax',
    materialCastings: 'Material Castings',
    castingProcess: 'Casting Process',
    industryType: 'Industry Type',
    naics: 'NAICS Codes',
    industryAssociations: 'Industry Affiliations',

  },
  // Pages
  HomePage: {
    mainHeader: 'Integrated Casting Order Network',
    subHeader:
      'Driving value to the Defense Logistics Agency (DLA) and domestic manufacturers b' +
      'y providing innovative procurement solutions for defense and military related me' +
      'tal castings.',
    subSubHeader:
      '*Please note some features available on the legacy site may not yet be enabled o' +
      'n the new site but will be added soon. We ask for your patience during this tran' +
      'sition.*',
    headerButton: 'Tooling Locations',
    info1: {
      header: 'New Business Opportunities',
      text:
        'ICON enables you to find the right opportunities through its integration with ma' +
        'jor defense procurement sites like FBO, DIBBS, NECO, and ASFI',
    },
    info2: {
      header: 'Comprehensive Data',
      text:
        'ICON is a comprehensive source for the information you need to determine which o' +
        'pportunities are right for your company',
    },
    info3: {
      header: 'Tailored Solution',
      text:
        'ICON delivers only casting solicitations matched to your manufacturing capabilit' +
        'ies.  Advanced filtering and sorting features save you valuable time and resourc' +
        'es',
    },
    info4: {
      header: 'ICON Portal',
      text: 'The ICON web portal transcends traditional bid matching services by providing a robust e-sourcing solution that filters, organizes, and delivers defense casting business opportunities to capable metalcasters by matching part requirements to a supplier’s manufacturing capabilities. Each solicitation is tailored to the foundry complete with data including full procurement history, estimated contract value, demand forecast, and a link to cFolders where you can view and download technical drawings to your laptop. The ICON portal is a time-saving resource and a must-have for any metalcaster seeking to maximize their business opportunities in the defense market.',
    },
    quote:
      '"AMC\'s Emergent Metal Casting Solutions (EMCS) Program is sponsored by the Defens' +
      'e Logistics Agency Troop Support, Philadelphia, PA and the Defense Logistics Age' +
      'ncy Research & Development (R&D) Office, Ft. Belvoir, VA"',
  },
  Registration: {
    header1: 'Find Your Organization',
    subheader: "Enter your email address and your organization's CAGE code",
    header2: 'Create Account',
    subheader2: 'Update/Enter your information',
    header3: 'Review your Organization',
    subheader3: 'verify that this is the organization you wish to join',
    header4: 'Request to Join',
    subheader4:
      'Your request will be viewed and approved by the appropriate admins',
    alreadyReg: 'Already Registered?',
    user: {
      name: 'Full Name',
      phone: 'Phone',
      Email: 'Email',
    },
    org: {
      organizationType: {
        member: 'Member',
        government: 'Government',
      },
      cage: 'CAGE Code',
      orgName: 'Organization Name',
      address: {
        address1: 'Address 1',
        address2: 'Address 2',
        address3: 'Address 3',
        city: 'City',
        state: 'State/Province',
        zipcode: 'ZIP/Postal Code',
        country: 'Country',
        websiteUrl: 'Website URL',
      },
    },
  },
  PdmiCredentials: {
    header: 'PDMI Password Update',
  },
  Tooling: {
    header: 'Request Tooling Locations',
    text:
      'Due to the proprietary information of the tooling database, unrestricted access ' +
      'is only granted to Department of Defense Personnel. However, any defense contrac' +
      'tor is able to make an inquiry to source casting suppliers and defense-related p' +
      'atterns using the following form. NFFS Staff will perform searches free of charge' +
      '. NFFS Staff will respond by e-mail within 3 business days with the status of yo' +
      'ur inquiry.',
    text2:
      'For each inquiry, the solicitation number associated with the part is required a' +
      'nd usually consists of at least 13 characters (SPM4A610Q1234 or SPM4A6-10-Q-1234' +
      '). In addition, your contact information must be submitted so that if a pattern ' +
      'is identified, NFFS can direct the supplier to contact you. All further communic' +
      'ations resulting from a search should be directed to the responding supplier. NF' +
      'FS assumes no further involvement and/or responsibility for the resulting busine' +
      'ss relationship. In addition, both parties must conduct such relationships with ' +
      'the full and proper adherence to the rights of ownership of customer provided to' +
      'oling.',
  },
  ProcurementHistory: {
    header: 'Search Procurement History',
    loading: 'Loading',
  },

  ToolingSearch: {
    header: 'Search Tooling, Inventory and Procurement History',
    col1: 'NSN',
    col2: 'Part Name',
    col3: 'Finished Part Number',
    col4: 'Tooling Location',
    loading: 'Loading',
  },
  ToolingMgmt: {
    header: 'Tooling Management',
    loading: 'Loading tools...',
  },
  About: {
    header: 'About ICON',
    section1: {
      text:
        'Non-Ferrous Founders’ Society is very proficient in creating and implementing re' +
        'sources to link capable metalcasting suppliers to the U.S. Department of Defense' +
        '’s part acquisition needs. These services are a product of the Society’s long-st' +
        'anding relationship with the American Metalcasting Consortium (AMC). AMC partner' +
        's with the Defense Logistics Agency (DLA) and the cast metals industry to provid' +
        'e resources that stimulate cost reductions, quality, and market share growth. NF' +
        'FS’s role in the AMC program is to deliver value to DLA while developing tools a' +
        'nd resources that promote business opportunities, efficiencies, and cost savings' +
        ' to the cast metals industry. What started as a simple concept of creating a dat' +
        'abase of tooling for defense applications has evolved into a sophisticated web p' +
        'ortal that has the potential to reshape the process by which manufacturers suppo' +
        'rt the defense market',
    },
    section2: {
      header: 'Background',
      text:
        'The ICON web portal is derived from one of the most successful (and award winnin' +
        'g) programs in recent years through the American Metalcasting Consortium (AMC), ' +
        'the Procurement Solutions Network for Castings. This web-based resource was crea' +
        'ted to simplify the procurement process for cast parts leveraging the integratio' +
        'n of a tooling database that cataloged the location of existing defense-related ' +
        'patterns; a casting supplier database of those foundries that manufacture parts ' +
        'for the defense industry, and a solicitation review process to quickly identify ' +
        'government procurements for cast components and direct them to capable metalcast' +
        'ing facilities. The initial process of monitoring these solicitations was conduc' +
        'ted manually using a confirmed casting part list, determine if tooling exists, a' +
        'nd direct the solicitations to capable casting suppliers leveraging the defense ' +
        'tooling database and the casting supplier database. The program to date has gene' +
        'rated thousands of new business orders for the cast metals industry and has docu' +
        'mented millions of dollars in cost savings for the government.',
      text2:
        'Despite the program’s successes, automation was the missing element to maximize ' +
        'the potential of this concept. Certainly there are many government and commercia' +
        'l bid matching sites in operation but leveraging these sites presented a host of' +
        ' challenges for manufacturers. The first challenge is the limitation of characte' +
        'ristics that a user had available to find opportunities. Common search parameter' +
        's are based on finished parts rather than manufacturing characteristics so for a' +
        ' foundry to find the solicitations that fit their production capabilities was vi' +
        'rtually impossible. A partial solution is to assist the foundry in developing a ' +
        'prospect list of known cast parts to receive solicitation notices on those items' +
        '. However, new cast parts are identified all of the time which requires one to a' +
        'ctively review and update their list.',
      text3:
        'Another barrier is solicitation data can often be deficient or fragmented among ' +
        'different sources. A foundry looking to quote a new job is not only going to nee' +
        'd the technical data to ensure that they have the capabilities to produce the pa' +
        'rt but they also need to review it from a business standpoint to determine if it' +
        ' is going to be profitable. Unfortunately the business and technical information' +
        ' are not all packaged together so it requires some legwork to put the pieces tog' +
        'ether to complete the review process. Common issues like unavailable drawings or' +
        ' procurement history can again result in a dead end.',
    },
    section3: {
      header: 'Integrated Casting Order Network',
      text:
        'The ICON web portal transcends traditional bid matching services by providing a ' +
        'robust e-sourcing solution that filters, organizes, and delivers defense casting' +
        ' business opportunities to capable metalcasters by matching part requirements to' +
        ' the supplier’s manufacturing capabilities. The architecture of the database, th' +
        'e web interface, and back-end resources have been developed to focus on the chal' +
        'lenge of assisting companies with manufacturing capabilities to utilize those sk' +
        'ills in the DoD marketplace either as a prime or sub-contractor.',
      text2:
        'Foundries using ICON can expect better results than using other bid matching and' +
        " government procurement sites through ICON's unique model because it is pre" +
        'sently tailored for defense casting applications. In the initial filtering proce' +
        'ss, the portal organizes the solicitations by material and process so that it wi' +
        'll automatically deliver only those solicitations that match a foundry user’s ca' +
        'pability profile. In addition, ICON verifies that technical data (drawings) is a' +
        'vailable for any given solicitation prior to delivery; otherwise the solicitatio' +
        'n is excluded from the results page. This saves the user time by eliminating the' +
        ' scenario of finding the right opportunity but not having the drawings available' +
        ' in order to quote.',
    },
  },

  cfolders: {
    drw_popup: 'Please Click ',
    drw_popup1: ' Proceed ',
    drw_popup2:
      'to continue, ICON is temporarily redirecting our users to the PDMI website. Enter your PDMI',
    drw_popup3: ' Username ',
    drw_popup4: 'and ',
    drw_popup5: ' Password ',
    drw_popup6:
      'to log in to the site. You will then be able to complete your download of the Zip file containing all technical documentation for the solicitation, including the requested drawing number(s). Please refer to the',
    drw_popup7: ' cFolders How To Page ',
    drw_popup8:
      'for more instructions on cFolder files including options for viewing different file formats (e.g., C4).',
  },

  Contact: {
    header: 'Contact Us',
    section1: {
      text:
        "The data development and maintenance is managed by the Non-Ferrous Founders' Soc" +
        'iety, a North American foundry trade association, as part of the American Metalc' +
        'asting Consortium’s  Casting Solutions for Readiness program.',
    },
    section2: {
      header: 'Please direct all inquiries to:',
    },
    address: {
      name: 'Matt Gilmore',
      company: "Non-Ferrous Founders' Society",
      line1: 'TBA',
      line2: 'TBA',
      phone: '(847) 268-4876',
      fax: '(847) 299-3598',
      email: 'matthewgilmore11@yahoo.com',
    },
  },
  LoginFailure: {
    header: 'Login Failure',
    section1: {
      text:
        "Unfortunately there was an error logging in. Please try again. If the problem persists please contact support using the email form below."
    },
    section2: {
      header: 'Contact details:',
    },
    address: {
      name: 'Matt Gilmore',
      company: "Non-Ferrous Founders' Society",
      line1: 'TBA',
      line2: 'TBA',
      phone: '(847) 268-4876',
      fax: '(847) 299-3598',
      email: 'matthewgilmore11@yahoo.com',
    },
  },
  SolicitationDetail: {
    header: 'Solicitation Details ',
    subheader: id => ['NSN#', <span> {id} </span>],
    InfoTableHeader: 'Info',
    RecentSolicitationHeader: 'Recent Solicitations',
    DrawingTableHeader: 'Drawings',
    ProcHistHeader: 'Procurement History',
    TechnicalCharHeader: 'Technical Characteristics',
    DescriptionHeader: 'Item Description',
    PackingInfoHeader: 'Packaging Information',
    solicitationId: 'Solicitation Id: ',
    castingType: 'Casting Type: ',
    nsnPart: 'NSN: ',
    fscCode: 'FSC Code: ',
    fscName: 'FSC Name: ',
    nomenclature: 'Nomenclature: ',
    techDocsLink: 'Tech Docs Link: ',
    issueDate: 'Date Issued: ',
    purchaseRequestNumber: 'Purchase Request Number: ',
    quantity: 'Quantity',
    solicitationAttributes: 'Solicitation Attributes: ',
    attachmentLinks: 'Attachment Links: ',
  },
  ToolingLocationSearch: {
    header: 'Please search for something',
  },
  BidMatchSettings: {
    header: 'Bid Matching Settings',
    subheader:
      'Manage your bid matching preferences by selecting from the options below.',
    noCardsFound:
      'No Bid Matching Settings Found'
  },
  SolicitationsSearch: {
    loading: 'Searching solicitations...',
  },
  SolicitationsSearchBar: {
    editBidMatching: 'Edit Bid Matching Settings...',
    hitsCount: hits => `${hits} solicitations found`,
  },

  accountAdmin: {
    header: 'Organization Administration',
  },
  superAdminHome: {
    header: 'Super Admin Home',
  },
  ViewUsers: {
    loading: 'Loading Users...',
    header: 'Organization Management',
  },
  AddUser: {
    addUser: 'Add a new user',
    requiredFields: 'Required fields are marked with an asterisk',
    required: 'Required',
    pageisLoading: 'Page is loading',
    emailInvalid: 'Please enter a valid email address',
    phoneNumberInvalid:
      'Please enter a valid phone number formatted as xxx-xxx-xxxx',
    fullName: 'Full Name',
    email: 'Email',
    phoneNumber: 'Phone Number',
    faxNumber: 'Fax Number',
    iconStatus: 'Icon Status',
    approved: 'Approved',
    blocked: 'Blocked',
    accountUser: 'Account User',
    accountAdmin: 'Account Admin',
    accountSuper: 'Super Admin',
    submit: 'Submit',
    // phoneNumberFormat: '999-999-9999',
  },
  EditUser: {
    header: 'Edit User',
    pageisLoading: 'Page is loading',
    emailInvalid: 'Please enter a valid email address',
    phoneNumberInvalid:
      'Please enter a valid phone number formatted as xxx-xxx-xxxx',
    fullName: 'Full Name',
    email: 'Email',
    phoneNumber: 'Phone Number',
    faxNumber: 'Fax Number',
    iconStatus: 'Icon Status',
    approved: 'Approved',
    blocked: 'Blocked',
    accountUser: 'Account User',
    accountAdmin: 'Account Admin',
    submit: 'Submit',
  },
  AddProduct: {
    header: 'Add Product',
  },
  EditTool: {
    header: 'Edit Product',
  },
  AddOrganization: {
    header: 'Add New Organization',
  },
  ToolingLocationsDetail: {
    header: 'Tooling Details',
    // subheader: niin => ['NIIN# ', <span>{niin}</span>],
    table1Header: 'Part Information',
    table2Header: 'Tooling Location & Technical Information',
  },
  ViewDetailsModal: {
    orgIconStatus: 'Organization Icon Status',
    orgType: 'Organization Type',
    userStatus: 'User Status',
    userType: 'User Type',
  },
  SupplierSearch: {
    Aluminum: 'Aluminum',
    Copper: 'Copper',
    Iron: 'Iron',
    MMC: 'Metal',
    Other: 'Other Non-Ferrous',
    Steel: 'Steel',
    Weight: 'Weight Range',
    Search: 'Search Suppliers',
  },
  ToolTips: {
    open: 'Solicitations with a status of “Open”',
    closed: 'Solicitations with a status of “Closed”',
    awarded: 'Solicitations with a status of “Awarded”',
    cancelled: 'Solicitations with a status of “Cancelled”',
    matches:
      "Solicitations matching your organization's bid match setting or for which your organization has a matching tooling record",
    flagged: 'Solicitations that you have flagged for follow up',
    tqb: 'Solicitations that you moved to “To be Quoted”',
    ip: 'Solicitations that you moved to “In Process”',
    archived: 'Solicitations that you moved to “Archived”',
  },
  Footer: {
    browserRequirements:
      'Use of ICON requires Internet Explorer 11, Mozilla Firefox or Google Chrome, with cookies and Javascript enabled',
  },
};



// WEBPACK FOOTER //
// ./src/config/messages.jsx